import styled from 'styled-components';

export const StepperPlaceholder = styled.div`
  height: 48px;
`;
